import { createApp } from 'vue';
import PngToJpgConverter from '../Components/PngToJpgConverter.vue';

const root = document.getElementById('png-to-jpg-converter');
if (root) {
  createApp(PngToJpgConverter).mount('#png-to-jpg-converter');
}
